export default __webpack_public_path__ + "static/media/IronTower.0c192467.jpg";